const otbFollowUpHeade = [
  // {
  //   group: 'Período',
  //   columns: [
  //     {
  //       name: 'Período',
  //       id: 'periodo-descricao',
  //       show: true
  //     }
  //   ]
  // },
  {
    group: 'Empresa',
    columns: [
      {
        name: 'Codigo',
        id: 'empresa-codigo',
        show: true
      }
    ]
  },
  {
    group: 'Categoria Compacta',
    columns: [
      {
        name: 'Codigo',
        id: 'categoria-compacta-codigo',
        show: true
      },
      {
        name: 'Descrição',
        id: 'categoria-compacta-descricao',
        show: true
      }
    ]
  },

  {
    group: 'Gerente Categoria',
    columns: [
      {
        name: 'Codigo',
        id: 'gerente-categoria-codigo',
        show: true
      },
      {
        name: 'Descrição',
        id: 'gerente-categoria-descricao',
        show: true
      }
    ]
  },
  {
    group: 'Gerente Produto',
    columns: [
      {
        name: 'Codigo',
        id: 'gerente-produto-codigo',
        show: true
      },
      {
        name: 'Descrição',
        id: 'gerente-produto-descricao',
        show: true
      }
    ]
  },

  // {
  //   group: 'Loja',
  //   columns: [
  //     {
  //       name: 'Codigo',
  //       id: 'loja-codigo',
  //       show: false
  //     },
  //     {
  //       name: 'Descrição',
  //       id: 'loja-descricao',
  //       show: false
  //     }
  //   ]
  // },
  // {
  //   group: 'Mundo',
  //   columns: [
  //     {
  //       name: 'Codigo',
  //       id: 'mundo-codigo',
  //       show: false
  //     },
  //     {
  //       name: 'Descrição',
  //       id: 'mundo-descricao',
  //       show: false
  //     }
  //   ]
  // },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Codigo',
        id: 'produto-codigo',
        show: true
      },
      {
        name: 'Descrição',
        id: 'produto-descricao',
        show: true
      }
    ]
  },
  {
    group: 'Categoria',
    columns: [
      {
        name: 'Codigo',
        id: 'categoria-codigo',
        show: true
      },
      {
        name: 'Descrição',
        id: 'categoria-descricao',
        show: true
      }
    ]
  },

  {
    group: 'Indicadores (R$)',
    columns: [
      {
        name: 'Estoque Inicial',
        id: 'indicador-estoque-inicial',
        show: true
      },
      {
        name: 'Estoque Atual',
        id: 'indicador-estoque-atual',
        show: true
      },
      // {
      //   name: 'Recebido Mês',
      //   id: 'indicador-rec-mes',
      //   show: true
      // },
      {
        name: 'Vendas Realizadas',
        id: 'indicador-vd-real',
        show: true
      },
      // {
      //   name: 'A Receber',
      //   id: 'indicador-areceber',
      //   show: true
      // },
      {
        name: 'Vendas Projetadas',
        id: 'indicador-vd-planej-pcl',
        show: true
      },
      {
        name: 'Estoque Planejado',
        id: 'indicador-vd-planej-proj',
        show: true
      },
      // {
      //   name: 'Open to By',
      //   id: 'indicador-open-to-by',
      //   show: true
      // },
      {
        name: 'Quantidade a Receber',
        id: 'indicador-estoque-final-ajust',
        show: true
      }
    ]
  },
  {
    group: 'Index',
    columns: [
      {
        name: '',
        id: 'index-index',
        show: false
      }
    ]
  }
]

export default otbFollowUpHeade
